<script setup lang="ts">
import PartnerCallsAndEvents from '../partners/PartnerCallsAndEvents.vue'
import CallCreate from '@/components/features/calls/CallCreate.vue'

const props = defineProps({
  partnerId: {
    type: Number,
    required: true,
  },
})
</script>

<template>
  <div class="bg-background text-primary p-2 text-center font-bold rounded-full w-full">
    Historique société
  </div>
  <CallCreate :partner-id="props.partnerId" />
  <PartnerCallsAndEvents :partner-id="partnerId" />
</template>
